import type { OptionResult } from '../../types/api';
import { usdT } from '../../lib/format';

export const COST_SERIES = [
  { key: 'feed', label: 'Feed (SC6)', color: 'var(--s-feed)' },
  { key: 'conversion', label: 'Conversion', color: 'var(--s-conversion)' },
  { key: 'logistics_duties', label: 'Logistics & duties', color: 'var(--s-logistics)' },
  { key: 'overheads', label: 'G&A', color: 'var(--s-overheads)' },
  { key: 'capital_charge', label: 'Capital charge', color: 'var(--s-capital)' },
] as const;

/** All-in cost per tonne as a stacked bar, with the realised revenue per tonne as a marker. */
export function CostStack({ option, max }: { option: OptionResult; max: number }) {
  const W = 300;
  const H = 22;
  const scale = (v: number) => (v / max) * W;
  let x = 0;
  const revenueX = Math.min(W, scale(option.revenue_usd_t));
  const title = COST_SERIES.map((s) => `${s.label}: ${usdT(option.cost_groups_usd_t[s.key])}`).join('\n') + `\nRevenue: ${usdT(option.revenue_usd_t)}`;
  return (
    <svg className="chart" viewBox={`0 0 ${W} ${H + 6}`} role="img" aria-label={`All-in cost ${usdT(option.all_in_cost_usd_t)} vs revenue ${usdT(option.revenue_usd_t)}`}>
      <title>{title}</title>
      {COST_SERIES.map((s) => {
        const w = Math.max(0, scale(option.cost_groups_usd_t[s.key]));
        const rect = <rect key={s.key} x={x} y={3} width={w} height={H - 6} fill={s.color} rx={1.5} />;
        x += w;
        return rect;
      })}
      <line x1={revenueX} x2={revenueX} y1={0} y2={H} stroke="var(--s-revenue)" strokeWidth={2.5} />
      <polygon points={`${revenueX - 4},${H + 5} ${revenueX + 4},${H + 5} ${revenueX},${H}`} fill="var(--s-revenue)" />
    </svg>
  );
}

export function CostLegend() {
  return (
    <div className="legend">
      {COST_SERIES.map((s) => <span key={s.key}><i style={{ background: s.color }} />{s.label}</span>)}
      <span><i style={{ background: 'var(--s-revenue)', width: 3 }} />Revenue per tonne</span>
    </div>
  );
}
